<div class="text-red-700 text-sm mt-1" *ngIf="form.get(key)?.invalid && form.get(key)?.touched">
  <small *ngIf="form.get(key)?.errors?.['required']">
    {{ 'FORM.REQUIRED' | translate:{ name: name } }}
  </small>
  <small *ngIf="form.get(key)?.errors?.['email']">
    {{ 'FORM.EMAIL_INVALID' | translate }}
  </small>
  <small *ngIf="form.get(key)?.errors?.['minlength']">
    {{ 'FORM.MIN_LENGTH' | translate:{ name: name, length: form.get(key)?.errors?.['minlength'].requiredLength } }}
  </small>
  <small *ngIf="form.get(key)?.errors?.['mismatch']">
    {{ 'FORM.MISMATCH' | translate:{ name: name } }}
  </small>
</div>
